import { HTTPService } from './httpService';

const API = new HTTPService();

const LogoService = {
  uploadLogo: async (installerId, file) => {
    const formData = new FormData();
    formData.append('logo', file);
    const response = await API.post(`/installer/${installerId}/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteLogo: async (installerId) => {
    const response = await API.delete(`/installer/${installerId}/logo`);
    return response.data;
  }
};

export default LogoService;
